/* VESPERA v2 – strona produktu: termin dostawy, przyklejony przycisk, kropki galerii */
(() => {
  const root = document.querySelector('[data-product]');
  if (!root) return;
  const $ = (s, el = root) => el.querySelector(s);
  const $$ = (s, el = root) => Array.from(el.querySelectorAll(s));
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const form = $('[data-product-form]');
  const addBtn = $('[data-add]');
  const fieldsets = $$('[data-option-index]');
  const bar = $('[data-pdp-bar]');
  const barVariant = $('[data-bar-variant]');
  const barPrice = $('[data-bar-price]');
  const barAdd = $('[data-bar-add]');

  /* Wybrane wartości opcji + pasek */
  const syncLabels = () => {
    fieldsets.forEach((fs) => {
      const out = $('[data-option-value]', fs);
      const c = $('input:checked', fs);
      if (out && c) out.textContent = c.value;
    });
    const sizeFs = fieldsets.find((fs) => $('[data-open-guide]', fs));
    const size = sizeFs && $('input:checked', sizeFs);
    if (barVariant && size) barVariant.textContent = size.value;
    const price = $('[data-price]');
    if (barPrice && price) barPrice.textContent = price.textContent;
    if (barAdd && addBtn) barAdd.disabled = addBtn.disabled;
  };
  fieldsets.forEach((fs) => fs.addEventListener('change', () => setTimeout(syncLabels, 0)));

  /* Kropki galerii na telefonie */
  const gallery = $('[data-gallery]');
  const dots = $$('.pdp__dots span');
  if (gallery && dots.length) {
    const items = $$('.pdp__media', gallery);
    const onScroll = () => {
      const step = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : gallery.clientWidth;
      const atEnd = gallery.scrollLeft + gallery.clientWidth >= gallery.scrollWidth - 4;
      const i = atEnd ? items.length - 1 : Math.round(gallery.scrollLeft / (step || 1));
      dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
    };
    gallery.addEventListener('scroll', () => requestAnimationFrame(onScroll), { passive: true });
  }

  /* Przewidywany termin dostawy z ustawienia „Czas dostawy” (dni robocze) */
  const eta = $('[data-eta]');
  if (eta) {
    const nums = (eta.dataset.eta.match(/\d+/g) || []).map(Number);
    if (nums.length >= 2 && nums[0] <= nums[1] && nums[1] < 60) {
      const addBusiness = (n) => {
        const d = new Date();
        let left = n;
        while (left > 0) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) left--; }
        return d;
      };
      const a = addBusiness(nums[0]);
      const b = addBusiness(nums[1]);
      const fmt = (d, month) => d.toLocaleDateString('pl-PL', month ? { day: 'numeric', month: 'short' } : { day: 'numeric' }).replace('.', '');
      const range = a.getMonth() === b.getMonth() ? `${fmt(a, false)}–${fmt(b, true)}` : `${fmt(a, true)} – ${fmt(b, true)}`;
      const text = $('[data-eta-text]', eta);
      if (text) text.innerHTML = `Zamów dziś – dostawa ok. <strong>${esc(range)}</strong>`;
    }
  }

  /* Przyklejony „Dodaj” na telefonie */
  if (bar && addBtn && form) {
    const footer = document.querySelector('.site-footer');
    let ticking = false;
    const sync = () => {
      ticking = false;
      const pastAdd = addBtn.getBoundingClientRect().bottom < 0;
      const nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      const show = pastAdd && !nearFooter;
      if (show === bar.classList.contains('is-visible')) return;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (barAdd) barAdd.tabIndex = show ? 0 : -1;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(sync); } }, { passive: true });
    sync();
    if (barAdd) barAdd.addEventListener('click', () => { if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click(); });
  }
})();
